// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */@media screen and (max-width:767px){.section-basic.card-image-grid[data-v-ffae4942]{padding:3.1rem 1.6rem 1.6rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
